import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import DatePicker from '../DatePicker';
import styles from './styles.scss';
import { toTimeString } from '../../../utils/dates';
import messages from '../../../constants/messages';

const defaultProps = {
  time: false,
};

class LabeledDatePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const { value } = this.props;
    this.validate(value);
  }

  validate(value) {
    const { onValidate } = this.props;
    if (!value) {
      onValidate(messages.validation.blankField, false);
    } else {
      onValidate();
    }
  }

  onChange(value) {
    const { onChange } = this.props;
    this.validate(value);
    onChange(value);
  }

  render() {
    const { editMode, label, value, isnLabel, placeholder, time, format, error, name } = this.props;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>

        <Choose>
          <When condition={editMode}>
            <DatePicker
              {...this.props}
              time={time}
              placeholder={placeholder}
              onChange={this.onChange}
              value={value}
              format={null}
              max={name === 'LastCalibration' ? new Date() : null}
            />
            {error && <label className={styles.error}>{error}</label>}
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{value ? toTimeString(value, '', format) : '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledDatePicker.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  type: PropTypes.string,
  onChange: PropTypes.func,
  isnLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  onValidate: PropTypes.func,
  time: PropTypes.bool,
  allowBlank: PropTypes.bool,
  format: PropTypes.string,
  error: PropTypes.string,
  name: PropTypes.string,
};

LabeledDatePicker.defaultProps = defaultProps;
export default LabeledDatePicker;



// WEBPACK FOOTER //
// src/components/shared/LabeledDatePicker/index.jsx